<template>
  <div class="dialog_wrap" @click="closeDialog">
    <div class="dialog_wrap_award" @click.stop="noTouch">
      <div class="dialog_wrap_close" @click="closeDialog"></div>
      <div class="wrap_award_content">
        <div class="wrap_award_title"></div>
        <div class="wrap_award_desc">
          <div class="award_title">
            {{ info.name }}
          </div>
          <div class="award_item">
            <img :src="info.gift" class="jiangli-icon">
          </div>
        </div>
        <div class="btn-ok" @click="tickBook">确定</div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
  name: 'AwardSuccess',
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    awardId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'awards'])
  },
  data () {
    return {
      info: {
        name: '',
        rate: '',
        ball: '',
        gift: ''
      }
    }
  },
  mounted () {
    document.getElementsByTagName('body')[0].classList.add('noscroll');
    if (this.awardId > 0) {
      var index = this.awards.findIndex(item => {
        if (item.id === this.awardId) {
          this.info = item
        }
      })
    }
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('noscroll');
  },
  methods: {
    noTouch () {

    },
    closeDialog () {
      if (this.$route.name === 'reservation') {
        this.$emit('onClose', true)
      } else {
        this.$router.push({ name: 'reservation', query: this.$route.query })
      }
    },
    tickBook () {
      this.$router.push({ name: 'reservationAwards', query: this.$route.query })
    }
  }
}
</script>

<style lang="scss">

</style>
